import { Component, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { NavController } from 'ionic-angular';
import { AtalhoConversa } from '../shared/abstract/atalho-conversa';
import { AreaAdmin } from '../../models/area';
import { NavProxyProvider } from '../../providers/nav-proxy/nav-proxy';
import { ConversaAreaGeralPage } from '../../pages/conversa-area-geral/conversa-area-geral';
//import { ConversaAreaGeralPage } from '../../pages/conversa-area-geral/conversa-area-geral';

@Component({
  selector: 'conversa-area-geral',
  templateUrl: 'conversa-area-geral.html'
})
export class ConversaAreaGeralComponent extends AtalhoConversa {

  @Input() areaAdmin: AreaAdmin;
  @Output() quantidadeMensagensNaoLidas: EventEmitter<number>;

  constructor(private navProxyProvider: NavProxyProvider) {
    super();
    this.quantidadeMensagensNaoLidas = new EventEmitter();
  }

  ngOnInit() {
    this.atualizarUltimaMensagem(this.areaAdmin.mensagensGerais);
  }

  ngOnChanges(changes: SimpleChanges) {
    this.atualizarUltimaMensagem(this.areaAdmin.mensagensGerais);
  }

  protected atualizarNumMensagensNaoLidas(): void {
    const mensagensGerais = this.areaAdmin.mensagensGerais;
    if (mensagensGerais) {
      this._quantidadeMensagensNaoLidas = mensagensGerais.filter(m => 
        m.origem === "L" && !m.statusMensagemLida).length;
      this.quantidadeMensagensNaoLidas.emit(this._quantidadeMensagensNaoLidas);
    }
  }

  public abrirConversa(): void {
    this.navProxyProvider.pushContent(ConversaAreaGeralPage, {
      areaAdmin: this.areaAdmin
    })
  }

}



// WEBPACK FOOTER //
// ./src/components/conversa-area-geral/conversa-area-geral.ts